import { PropertyUnits } from "./model-units";

export class ReqAddUnits{
    units: Array<PropertyUnits>;

    constructor(units: Array<PropertyUnits>){
        this.units = units;
    }
}